import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { ApiVisa, BaseApiTemplateService, Core2Config, PagingResponseModel } from '../shared';


@Injectable({providedIn: 'root'})
export class ListingService extends BaseApiTemplateService<any>{
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'listing';


  protected httpClient: HttpClient;

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'listing';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'listing';
    this.httpClient = http;
  }

  public getEcomSyncItemListing(title: string, inputModel: any, apiVisa: ApiVisa): Observable<PagingResponseModel<any>> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }

    let formData = {};

    if (inputModel) formData = inputModel;
    
    this.apiUrl += "/" + title;
    return this.httpClient.post<PagingResponseModel<any>>(
      this.apiUrl,
      formData,
      this.getHttpHeader(apiVisa)
    );
  }
}
